// ======================================================================
// File: src/modules/ipe/dashboard/crm/pages/CRMOperationsDashboard.jsx
// Purpose:
// CRM Operations Dashboard
// Daily Sales Execution & Follow-up Monitoring
// ======================================================================

import React from "react";

export default function CRMOperationsDashboard() {
  return (
    <div>

      {/* =====================================================
          PAGE HEADER
      ===================================================== */}

      <div
        style={{
          background:
            "linear-gradient(135deg,#059669,#10b981)",
          borderRadius: "16px",
          padding: "20px",
          color: "#fff",
          marginBottom: "20px",
          boxShadow:
            "0 8px 24px rgba(16,185,129,.25)",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontWeight: 700,
          }}
        >
          CRM Operations Dashboard
        </h2>

        <div
          style={{
            marginTop: "8px",
            opacity: 0.9,
          }}
        >
          Daily Sales Execution, Follow-up Management,
          Opportunity Tracking and Quotation Monitoring
        </div>
      </div>

      {/* =====================================================
          KPI SECTION
      ===================================================== */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(220px,1fr))",
          gap: "16px",
          marginBottom: "24px",
        }}
      >

        {/* Follow Ups */}

        <div
          className="card"
          style={{
            padding: "18px",
            borderRadius: "12px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#64748b",
            }}
          >
            Follow Ups Due
          </div>

          <div
            style={{
              fontSize: "30px",
              fontWeight: 700,
              color: "#059669",
              marginTop: "6px",
            }}
          >
            24
          </div>

          <div
            style={{
              marginTop: "6px",
              fontSize: "12px",
              color: "#16a34a",
            }}
          >
            ▲ 12% vs Yesterday
          </div>
        </div>

        {/* Quotations */}

        <div
          className="card"
          style={{
            padding: "18px",
            borderRadius: "12px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#64748b",
            }}
          >
            Pending Quotations
          </div>

          <div
            style={{
              fontSize: "30px",
              fontWeight: 700,
              color: "#2563eb",
              marginTop: "6px",
            }}
          >
            18
          </div>

          <div
            style={{
              marginTop: "6px",
              fontSize: "12px",
              color: "#2563eb",
            }}
          >
            ₹ 2.84 Cr
          </div>
        </div>

        {/* Opportunities */}

        <div
          className="card"
          style={{
            padding: "18px",
            borderRadius: "12px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#64748b",
            }}
          >
            Open Opportunities
          </div>

          <div
            style={{
              fontSize: "30px",
              fontWeight: 700,
              color: "#7c3aed",
              marginTop: "6px",
            }}
          >
            46
          </div>

          <div
            style={{
              marginTop: "6px",
              fontSize: "12px",
              color: "#7c3aed",
            }}
          >
            Pipeline Active
          </div>
        </div>

        {/* Orders Won */}

        <div
          className="card"
          style={{
            padding: "18px",
            borderRadius: "12px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#64748b",
            }}
          >
            Orders Won
          </div>

          <div
            style={{
              fontSize: "30px",
              fontWeight: 700,
              color: "#16a34a",
              marginTop: "6px",
            }}
          >
            11
          </div>

          <div
            style={{
              marginTop: "6px",
              fontSize: "12px",
              color: "#16a34a",
            }}
          >
            This Month
          </div>
        </div>

      </div>

      
      {/* =====================================================
    TODAY'S ACTION CENTER
===================================================== */}

<div
  style={{
    marginBottom: "24px",
  }}
>
  <div
    style={{
      fontSize: "18px",
      fontWeight: 700,
      marginBottom: "12px",
      color: "#111827",
    }}
  >
    Today's Action Center
  </div>

  <div
    style={{
      display: "grid",
      gridTemplateColumns:
        "repeat(auto-fit,minmax(220px,1fr))",
      gap: "16px",
    }}
  >
    <div
      className="card"
      style={{
        padding: "18px",
        borderRadius: "12px",
        borderLeft: "4px solid #2563eb",
      }}
    >
      <div
        style={{
          fontSize: "12px",
          color: "#64748b",
        }}
      >
        Calls Pending
      </div>

      <div
        style={{
          fontSize: "28px",
          fontWeight: 700,
          color: "#2563eb",
          marginTop: "8px",
        }}
      >
        12
      </div>
    </div>

    <div
      className="card"
      style={{
        padding: "18px",
        borderRadius: "12px",
        borderLeft: "4px solid #10b981",
      }}
    >
      <div
        style={{
          fontSize: "12px",
          color: "#64748b",
        }}
      >
        Meetings Scheduled
      </div>

      <div
        style={{
          fontSize: "28px",
          fontWeight: 700,
          color: "#10b981",
          marginTop: "8px",
        }}
      >
        5
      </div>
    </div>

    <div
      className="card"
      style={{
        padding: "18px",
        borderRadius: "12px",
        borderLeft: "4px solid #f59e0b",
      }}
    >
      <div
        style={{
          fontSize: "12px",
          color: "#64748b",
        }}
      >
        Site Visits
      </div>

      <div
        style={{
          fontSize: "28px",
          fontWeight: 700,
          color: "#f59e0b",
          marginTop: "8px",
        }}
      >
        3
      </div>
    </div>

    <div
      className="card"
      style={{
        padding: "18px",
        borderRadius: "12px",
        borderLeft: "4px solid #dc2626",
      }}
    >
      <div
        style={{
          fontSize: "12px",
          color: "#64748b",
        }}
      >
        Quotations Due
      </div>

      <div
        style={{
          fontSize: "28px",
          fontWeight: 700,
          color: "#dc2626",
          marginTop: "8px",
        }}
      >
        7
      </div>
    </div>
  </div>
</div>
      {/* =====================================================
          FOLLOW UP WORKBENCH
      ===================================================== */}

      <div
        className="card"
        style={{
          padding: "18px",
          marginBottom: "24px",
          borderRadius: "12px",
        }}
      >
        <h4
          style={{
            marginTop: 0,
            marginBottom: "16px",
          }}
        >
          Today's Follow-up Workbench
        </h4>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr
              style={{
                background: "#f8fafc",
              }}
            >
              <th style={{ padding: "10px", textAlign: "left" }}>
                Customer
              </th>

              <th style={{ padding: "10px", textAlign: "left" }}>
                Contact
              </th>

              <th style={{ padding: "10px", textAlign: "left" }}>
                Due Time
              </th>

              <th style={{ padding: "10px", textAlign: "left" }}>
                Priority
              </th>

              <th style={{ padding: "10px", textAlign: "left" }}>
                Status
              </th>
            </tr>
          </thead>

          <tbody>

            <tr>
              <td style={{ padding: "10px" }}>L&T</td>
              <td style={{ padding: "10px" }}>Mr Rao</td>
              <td style={{ padding: "10px" }}>11:00 AM</td>
              <td style={{ padding: "10px" }}>High</td>
              <td style={{ padding: "10px" }}>Pending</td>
            </tr>

            <tr>
              <td style={{ padding: "10px" }}>
                Tata Projects
              </td>
              <td style={{ padding: "10px" }}>
                Mr Sharma
              </td>
              <td style={{ padding: "10px" }}>
                03:00 PM
              </td>
              <td style={{ padding: "10px" }}>
                Medium
              </td>
              <td style={{ padding: "10px" }}>
                Scheduled
              </td>
            </tr>

          </tbody>
        </table>
      </div>

      {/* =====================================================
    SALES TEAM PERFORMANCE
===================================================== */}

<div
  className="card"
  style={{
    padding: "18px",
    borderRadius: "12px",
    marginBottom: "24px",
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
    }}
  >
    <h4
      style={{
        margin: 0,
      }}
    >
      Sales Team Performance
    </h4>

    <span
      style={{
        fontSize: "12px",
        color: "#64748b",
      }}
    >
      Current Month
    </span>
  </div>

  <table
    style={{
      width: "100%",
      borderCollapse: "collapse",
    }}
  >
    <thead>
      <tr
        style={{
          background: "#f8fafc",
        }}
      >
        <th
          style={{
            padding: "12px",
            textAlign: "left",
          }}
        >
          Executive
        </th>

        <th
          style={{
            padding: "12px",
            textAlign: "center",
          }}
        >
          Follow-ups
        </th>

        <th
          style={{
            padding: "12px",
            textAlign: "center",
          }}
        >
          Quotations
        </th>

        <th
          style={{
            padding: "12px",
            textAlign: "center",
          }}
        >
          Orders
        </th>

        <th
          style={{
            padding: "12px",
            textAlign: "right",
          }}
        >
          Revenue
        </th>
      </tr>
    </thead>

    <tbody>

      <tr>
        <td style={{ padding: "12px" }}>
          Ravi Kumar
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "center",
          }}
        >
          18
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "center",
          }}
        >
          6
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "center",
            color: "#16a34a",
            fontWeight: 700,
          }}
        >
          2
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "right",
            fontWeight: 600,
          }}
        >
          ₹82 Lakhs
        </td>
      </tr>

      <tr>
        <td style={{ padding: "12px" }}>
          Sharma
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "center",
          }}
        >
          15
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "center",
          }}
        >
          4
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "center",
            color: "#16a34a",
            fontWeight: 700,
          }}
        >
          1
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "right",
            fontWeight: 600,
          }}
        >
          ₹55 Lakhs
        </td>
      </tr>

      <tr>
        <td style={{ padding: "12px" }}>
          Priya
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "center",
          }}
        >
          12
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "center",
          }}
        >
          5
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "center",
            color: "#16a34a",
            fontWeight: 700,
          }}
        >
          3
        </td>

        <td
          style={{
            padding: "12px",
            textAlign: "right",
            fontWeight: 600,
          }}
        >
          ₹1.12 Cr
        </td>
      </tr>

    </tbody>
  </table>
</div>
      {/* =====================================================
    OVERDUE FOLLOWUPS + LOST OPPORTUNITIES
===================================================== */}

<div
  style={{
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(450px,1fr))",
    gap: "16px",
    marginTop: "24px",
  }}
>

  {/* =====================================================
      OVERDUE FOLLOWUPS
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "16px",
      }}
    >
      Overdue Follow-ups
    </h4>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
      }}
    >
      <thead>
        <tr
          style={{
            background: "#f8fafc",
          }}
        >
          <th
            style={{
              padding: "10px",
              textAlign: "left",
            }}
          >
            Customer
          </th>

          <th
            style={{
              padding: "10px",
              textAlign: "center",
            }}
          >
            Days Overdue
          </th>

          <th
            style={{
              padding: "10px",
              textAlign: "left",
            }}
          >
            Executive
          </th>
        </tr>
      </thead>

      <tbody>

        <tr>
          <td style={{ padding: "10px" }}>
            L&T
          </td>

          <td
            style={{
              padding: "10px",
              textAlign: "center",
              color: "#dc2626",
              fontWeight: 700,
            }}
          >
            4
          </td>

          <td style={{ padding: "10px" }}>
            Ravi
          </td>
        </tr>

        <tr>
          <td style={{ padding: "10px" }}>
            Tata Projects
          </td>

          <td
            style={{
              padding: "10px",
              textAlign: "center",
              color: "#dc2626",
              fontWeight: 700,
            }}
          >
            3
          </td>

          <td style={{ padding: "10px" }}>
            Sharma
          </td>
        </tr>

        <tr>
          <td style={{ padding: "10px" }}>
            Adani
          </td>

          <td
            style={{
              padding: "10px",
              textAlign: "center",
              color: "#f59e0b",
              fontWeight: 700,
            }}
          >
            2
          </td>

          <td style={{ padding: "10px" }}>
            Priya
          </td>
        </tr>

      </tbody>
    </table>
  </div>

  {/* =====================================================
      LOST OPPORTUNITY ANALYSIS
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "20px",
      }}
    >
      Lost Opportunity Analysis
    </h4>

    {[
      {
        reason: "Price Issue",
        value: 45,
        color: "#dc2626",
      },
      {
        reason: "Competitor Won",
        value: 30,
        color: "#f59e0b",
      },
      {
        reason: "Technical Gap",
        value: 15,
        color: "#2563eb",
      },
      {
        reason: "Budget Constraints",
        value: 10,
        color: "#64748b",
      },
    ].map((item) => (
      <div
        key={item.reason}
        style={{
          marginBottom: "18px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            marginBottom: "6px",
          }}
        >
          <span>
            {item.reason}
          </span>

          <strong>
            {item.value}%
          </strong>
        </div>

        <div
          style={{
            height: "10px",
            background: "#e5e7eb",
            borderRadius: "999px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${item.value}%`,
              height: "100%",
              background: item.color,
            }}
          />
        </div>
      </div>
    ))}
  </div>

</div>
      
      {/* =====================================================
          QUOTATIONS + PIPELINE
      ===================================================== */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(450px,1fr))",
          gap: "16px",
        }}
      >

        {/* Pending Quotations */}

        <div
          className="card"
          style={{
            padding: "18px",
            borderRadius: "12px",
          }}
        >
          <h4
            style={{
              marginTop: 0,
            }}
          >
            Pending Quotations
          </h4>

          <div style={{ marginBottom: "12px" }}>
            QT-1001 - ₹25 Lakhs
          </div>

          <div style={{ marginBottom: "12px" }}>
            QT-1002 - ₹42 Lakhs
          </div>

          <div>
            QT-1003 - ₹18 Lakhs
          </div>
        </div>

        {/* Pipeline */}

        <div
          className="card"
          style={{
            padding: "18px",
            borderRadius: "12px",
          }}
        >
          <h4
            style={{
              marginTop: 0,
            }}
          >
            Opportunity Pipeline
          </h4>

          <div style={{ marginBottom: "10px" }}>
            Lead : 46
          </div>

          <div style={{ marginBottom: "10px" }}>
            Qualified : 24
          </div>

          <div style={{ marginBottom: "10px" }}>
            Proposal : 18
          </div>

          <div style={{ marginBottom: "10px" }}>
            Negotiation : 8
          </div>

          <div
            style={{
              color: "#16a34a",
              fontWeight: 600,
              marginBottom: "10px",
            }}
          >
            Won : 11
          </div>

          <div
            style={{
              color: "#dc2626",
              fontWeight: 600,
            }}
          >
            Lost : 4
          </div>

        </div>

      </div>

    </div>
  );
}